import _styled from "styled-components";
import React from 'react';
import { CloseButton } from "../../../elements/IconButtons/CloseButton";
import * as styles from "../styles/Header.styles";
export var Header = function Header(_ref) {
  var children = _ref.children,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'default' : _ref$layout,
    _ref$notificationStat = _ref.notificationStatus,
    notificationStatus = _ref$notificationStat === void 0 ? 'normal' : _ref$notificationStat,
    onCloseButtonClick = _ref.onCloseButtonClick;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-success": notificationStatus === 'success',
    $_css: [styles.headerWrapper, styles[layout]]
  }, children, /*#__PURE__*/React.createElement(CloseButton, {
    "aria-label": "Close dialog",
    onClick: onCloseButtonClick,
    size: "large"
  }));
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "Header___StyledDiv",
  componentId: "sc-1p5l0ti-0"
})(["", ""], function (p) {
  return p.$_css;
});